import { compareStatus } from "@gearbox-protocol/cli-utils";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
export const SELECT_ALL = "__all__";
/** Filter value for services that are not related to any single network */
export const OTHER_NETWORKS = "others";
function sortServicesByStatus(services) {
    return [...services].sort((a, b) => compareStatus(b.status, a.status));
}
export function useMonitoringFilters(data) {
    const [filters, setFilters] = useState({
        network: undefined,
        family: undefined,
    });
    const { hash } = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        setFilters(prev => ({
            ...prev,
            network: hash ? hash.split("#")[1] || undefined : undefined,
        }));
    }, [hash]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: <>
    return useMemo(() => {
        const services = [];
        const networks = new Set();
        const families = new Set();
        let hasOthers = false;
        for (const s of data.services) {
            const networkMatch = !filters.network ||
                (filters.network === OTHER_NETWORKS
                    ? !s.network
                    : s.network === filters.network);
            const familyMatch = !filters.family || s.family === filters.family;
            if (networkMatch && familyMatch) {
                services.push(s);
            }
            if (s.network) {
                networks.add(s.network);
            }
            else {
                hasOthers = true;
            }
            if (s.family) {
                families.add(s.family);
            }
        }
        const sortedServices = sortServicesByStatus(services);
        return {
            services: sortedServices,
            networks: Array.from(networks).sort(),
            hasOthers,
            families: Array.from(families).sort(),
            network: filters.network ?? SELECT_ALL,
            setNetwork: (network) => {
                navigate(network && network !== SELECT_ALL ? `#${network}` : "#");
            },
            family: filters.family,
            setFamily: (family) => setFilters({
                ...filters,
                family: family === SELECT_ALL ? undefined : family,
            }),
        };
    }, [data.services, filters, hash, navigate]);
}
